var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.306252 0.539111C0.215251 0.577362 0.137609 0.641693 0.0831099 0.723998C0.0286107 0.806303 -0.000306814 0.902898 1.98865e-06 1.00161L2.42576e-06 11.0016C-0.000306368 11.1003 0.0286112 11.1969 0.0831104 11.2792C0.13761 11.3615 0.215252 11.4259 0.306253 11.4641C0.398608 11.5001 0.499275 11.5093 0.596607 11.4905C0.69394 11.4717 0.783959 11.4257 0.856252 11.3579L5.85625 6.35786C5.94866 6.26229 6.00032 6.13455 6.00032 6.00161C6.00032 5.86867 5.94866 5.74093 5.85625 5.64536L0.856252 0.645361C0.783959 0.577531 0.693939 0.531555 0.596607 0.512753C0.499274 0.49395 0.398607 0.503088 0.306252 0.539111Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandClose);
export default __webpack_public_path__ + "static/media/expand-close.bfe4c5475eec9456527be1382a3b3d57.svg";
export { ForwardRef as ReactComponent };